
import {StackSetsDeployment} from "../../../utils/types/deployments/stacksets/deployment";
import {BASE_URL, HandleErrorResponse} from "../../common";
import {StackSetsDeploymentApiService} from "./service";
import {GenericDeploymentSubmissionResponse} from "../../../utils/types/deployments/genericDeploymentResponse";
import {GenericServiceSummary} from "../../../utils/types/genericServiceSummaryItem";

export class MainStackSetsDeploymentApiService implements StackSetsDeploymentApiService {
    readonly adminBasePath = `${BASE_URL}/pcsk-admin/deployments/stacksets`;
    async getDeployments(): Promise<StackSetsDeployment[]> {
        const endpoint = `${this.adminBasePath}`;

        try {
            const response = await fetch(endpoint, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
                    'Content-Type': 'application/json',
                }
            });

            if (!response.ok) {
                await HandleErrorResponse(response);
            }

            const resp = await response.json();
            return StackSetsDeployment.fromJSON(resp)
        } catch (error) {
            console.error("Error fetching stacksets deployments:", error);
            throw error;
        }
    }

    async deployCommit(changeCase: string, implStepID: string, commitID: string, commitTitle: string, force: boolean, auto: boolean, dryRun: boolean): Promise<GenericDeploymentSubmissionResponse> {
        const endpoint = `${this.adminBasePath}/new`;

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    commit_id: commitID,
                    implementation_step_id: implStepID,
                    auto: auto,
                    force: force,
                    change_case: changeCase,
                    dry_run: dryRun,
                    commit_title: commitTitle,
                })
            });

            if (!response.ok) {
                await HandleErrorResponse(response);
            }

            const resp = await response.json();
            return GenericDeploymentSubmissionResponse.fromJSON(resp)
        } catch (error) {
            console.error("Error starting new deployment:", error);
            throw error;
        }
    }

    async expandCommit(changeCase: string, implStepID: string, commitID: string, commitTitle: string, force: boolean, auto: boolean, dryRun: boolean): Promise<GenericDeploymentSubmissionResponse> {
        const endpoint = `${this.adminBasePath}/expand`;

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    commit_id: commitID,
                    commit_title: commitTitle,
                    auto: auto,
                    force: force,
                    change_case: changeCase,
                    implementation_step_id: implStepID,
                    dry_run: dryRun,
                })
            });

            if (!response.ok) {
                await HandleErrorResponse(response);
            }

            const resp = await response.json();
            return GenericDeploymentSubmissionResponse.fromJSON(resp)
        } catch (error) {
            console.error("Error expanding commit:", error);
            throw error;
        }
    }

    async revertCommit(changeCase: string, implStepID: string, commitID: string, commitTitle: string, revertCommitID: string, force: boolean, dryRun: boolean): Promise<GenericDeploymentSubmissionResponse> {
        const endpoint = `${this.adminBasePath}/revert`;

        try {
            const response = await fetch(endpoint, {
                method: 'POST',
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    commit_id: commitID,
                    commit_title: commitTitle,
                    revert_commit_id: revertCommitID,
                    force: force,
                    change_case: changeCase,
                    implementation_step_id: implStepID,
                    dry_run: dryRun,
                })
            });

            if (!response.ok) {
                await HandleErrorResponse(response);
            }

            const resp = await response.json();
            return GenericDeploymentSubmissionResponse.fromJSON(resp)
        } catch (error) {
            console.error("Error reverting commit:", error);
            throw error;
        }
    }

    async getSummary(): Promise<GenericServiceSummary> {
        try {
            const finalURI = `${BASE_URL}/pcsk-admin/summary/deployments/stacksets`;
            const response = await fetch(finalURI, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('access_token')
                },
            });

            if (!response.ok) {
                await HandleErrorResponse(response);
            }

            const jsonResp: any[] = await response.json();
            return GenericServiceSummary.fromJSON(jsonResp);

        } catch (error) {
            console.error("Error fetching stacksets deployment summary :", error);
            throw error;

        }
    }
}
